import axios from "axios";

export let baseUrl = `${process.env.REACT_APP_BASE_URL}api/`;
export const socketUrl = process.env.REACT_APP_BASE_URL;

const api = async (path, params, method) => {
  let options;
  options = {
    headers: {
      "Content-Type": "application/json",
    },
    method: method,
    ...(params && { data: JSON.stringify(params) }),
  };
  return axios(baseUrl + path, options)
    .then((response) => {
      return response;
    })
    .catch(async (error) => {
      return error.response;
    });
};

export default api;
